import { a as h } from "./utilities-CRRpLwsZ.js";
import { f as l } from "./dawn-ByQXfp5G.js";
import { p as d } from "./pubsub-_CAGtZQ9.js";
import { P as u } from "./constants-IUqmZVfP.js";
class m extends HTMLElement {
  constructor() {
    super(),
      (this.form = this.querySelector("form")),
      (this.form.querySelector("[name=id]").disabled = !1),
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
      (this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer")),
      (this.submitButton = this.querySelector('[type="submit"]')),
      (this.rechargeContainer = document.querySelector(
        "[data-recharge-container]"
      )),
      document.querySelector("cart-drawer") &&
        this.submitButton.setAttribute("aria-haspopup", "dialog"),
      (this.hideErrors = this.dataset.hideErrors === "true");
  }
  connectedCallback() {
    this.rechargeContainer && this.observeRechargeContainer();
  }
  disconnectedCallback() {
    var e;
    this.rechargeContainer && ((e = this.rcObserver) == null || e.disconnect());
  }
  observeRechargeContainer() {
    this.rechargeContainer &&
      ((this.rcObserver = new MutationObserver((e, i) => {
        var r;
        for (const t of e)
          if (t.type === "childList") {
            const s = t.addedNodes[0];
            (r = s == null ? void 0 : s.classList) != null &&
              r.contains("rc-widget") &&
              ([...s.querySelectorAll(".rc-radio__label")].forEach((c) => {
                let a = c.textContent
                  .replace(window.Shopify.currency.active, "")
                  .trim();
                (a = a
                  .split(" ")
                  .map((n) =>
                    n.includes(this.dataset.currencySymbol)
                      ? `<strong>${n}</strong>`
                      : n
                  )
                  .join(" ")),
                  (c.innerHTML = a);
              }),
              i.disconnect());
          }
      })),
      this.rcObserver.observe(this.rechargeContainer, {
        subtree: !0,
        childList: !0,
      }));
  }
  onSubmitHandler(e) {
    if (
      (e.preventDefault(),
      this.submitButton.getAttribute("aria-disabled") === "true")
    )
      return;
    this.handleErrorMessage(),
      this.submitButton.setAttribute("aria-disabled", !0),
      this.submitButton.classList.add("loading"),
      this.querySelector(".loading__spinner").classList.remove("hidden");
    const i = l("javascript");
    (i.headers["X-Requested-With"] = "XMLHttpRequest"),
      delete i.headers["Content-Type"];
    const r = new FormData(this.form);
    this.cart &&
      (r.append(
        "sections",
        this.cart.getSectionsToRender().map((t) => t.id)
      ),
      r.append("sections_url", window.location.pathname),
      this.cart.setActiveElement(document.activeElement)),
      (i.body = r),
      fetch(`${routes.cart_add_url}`, i)
        .then((t) => t.json())
        .then((t) => {
          if (t.status) {
            d(u.cartError, {
              source: "product-form",
              productVariantId: r.get("id"),
              errors: t.errors || t.description,
              message: t.message,
            }),
              this.handleErrorMessage(t.description);
            const o = this.submitButton.querySelector(".sold-out-message");
            if (!o) return;
            this.submitButton.setAttribute("aria-disabled", !0),
              this.submitButton.querySelector("span").classList.add("hidden"),
              o.classList.remove("hidden"),
              (this.error = !0);
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error ||
            d(u.cartUpdate, {
              source: "product-form",
              productVariantId: r.get("id"),
              cartData: t,
            }),
            (this.error = !1);
          const s = this.closest("quick-add-modal");
          s
            ? (document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(t);
                  });
                },
                { once: !0 }
              ),
              s.hide(!0))
            : this.cart.renderContents(t);
        })
        .catch((t) => {
          console.error(t);
        })
        .finally(() => {
          this.submitButton.classList.remove("loading"),
            this.cart &&
              this.cart.classList.contains("is-empty") &&
              this.cart.classList.remove("is-empty"),
            this.error || this.submitButton.removeAttribute("aria-disabled"),
            this.querySelector(".loading__spinner").classList.add("hidden");
        });
  }
  handleErrorMessage(e = !1) {
    this.hideErrors ||
      ((this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper")),
      this.errorMessageWrapper &&
        ((this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          )),
        this.errorMessageWrapper.toggleAttribute("hidden", !e),
        e && (this.errorMessage.textContent = e)));
  }
}
h("product-form", m);
